// extracted by mini-css-extract-plugin
module.exports = {"CarouselContainer":"StepsCarrousel_CarouselContainer__dg7mK","ContainerTitle":"StepsCarrousel_ContainerTitle__2Re1M","SectionTitle":"StepsCarrousel_SectionTitle__3aKUU"};